<div class="toastr">
  <div class="toastr-icon">
    <od-svg-icon class="svg-wrapper"
      [name]="'icon-' + toastPackage.toastType"
    ></od-svg-icon>
    <div class="toastr-text text-xs">
      @if (title()) {
        <span><b>{{ title() }}</b></span>
      }
      <span>{{ message() }}</span>
    </div>
  </div>
  @if (options()['action']) {
    <button class="toastr-btn text-2xs-bold" (click)="doAction($event, options()['action'])">{{ options()['action'] | titlecase }}</button>
  }
  <span (click)="dismiss()" class="close-btn" aria-label="Cancel">
    <od-svg-icon class="svg-wrapper" name="icon-close"></od-svg-icon>
  </span>
</div>
